export type ActiveLSPayTransaction = {
  registerSaleId: string
  paymentIntentId?: string
  registerSalePaymentId: string
  amount: string | number
}

// localStorage key for active lspay transaction details,
// which used to recover the transaction from a unexpected refresh/browser crash
export const ACTIVE_LSPAY_TRANSACTION = 'activeLSPayTransaction'
